import { combineReducers, configureStore } from "@reduxjs/toolkit";

// import reducer from './reducer';
import authReducer from "./slices/auth";
import loadReducer from "./slices/loadingStatus";
import messageReducer from "./slices/message";
import snackbarReducer from "./slices/snackbar";
import utilitiesReducer from "./slices/utilities";

// ==============================|| REDUX - MAIN STORE ||============================== //

const reducer = combineReducers({
  auth: authReducer,
  load: loadReducer,
  message: messageReducer,
  snackbar: snackbarReducer,
  utils: utilitiesReducer,
});

const store = configureStore({
  reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
const persister = "Free";

export { persister, store };
